import { render, staticRenderFns } from "./SalesStatistics.vue?vue&type=template&id=2a4b01cf&scoped=true&"
import script from "./SalesStatistics.vue?vue&type=script&lang=ts&"
export * from "./SalesStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./SalesStatistics.vue?vue&type=style&index=0&id=2a4b01cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b01cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4b01cf')) {
      api.createRecord('2a4b01cf', component.options)
    } else {
      api.reload('2a4b01cf', component.options)
    }
    module.hot.accept("./SalesStatistics.vue?vue&type=template&id=2a4b01cf&scoped=true&", function () {
      api.rerender('2a4b01cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesStatistics.vue"
export default component.exports